import React from 'react'; 
 
const OTPDisclaimer = (props) => {

    const {isExistingOTP} = props;

    return (
        <div className="row around-xs">
            {(isExistingOTP === 'N')?
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                {/* <div style={{display:'-webkit-inline-box'}}>
                    <ul className='lbl-note-grey aip-otp-txt'>
                        <li key={'i1'}>{'Note:'}</li>
                        <li key={'i2'}>{'Your property loan eligibility is further subject to the following requirements:'}
                            <ul className='dotlist'>
                                <li>{'Property financing only'}</li>
                                <li>{'Purpose of property for Business Operations'}</li>
                                <li>{'Property is located at acceptable locations'}</li>
                                <li>{'Minimum 1 year of incorporation'}</li>
                                <li>{'Excludes Sole Proprietorship or Refinancing'}</li>
                            </ul>
                        </li>
                    </ul>
                </div> */}
                <div className='lbl-note-grey aip-otp-txt inputPair otp-note-margin'>
                    {'This Approval In-Principle is given based on the information provided by you herein, and is subject to full evaluation upon submission of your application. It does not constitute an offer of loan, nor does it imply an undertaking, warranty or representation to grant the loan. We reserve the right, at our absolute discretion, to revoke or modify the Approval In-Principle at our sole discretion.'}
                </div>
            </div>
            :
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div style={{display:'-webkit-inline-box'}}>
                    <ul className='lbl-note-grey aip-otp-txt'>
                        <li key={'k1'}>{'Note:'}</li>
                        <li key={'k2'}>{'Please note that no Approval In-Principle will be provided. Our dedicated sales personnel will be in touch with you if your application is successful.'}</li>
                    </ul>
                </div>
            </div>
        }
        </div>
    )
}

export default OTPDisclaimer;